// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15oEU","left":"styles_left__3Sj8u"};